import { DefaultButton } from "@fluentui/react";
import styled from "styled-components";

export const AbortButton = styled(DefaultButton)`
  position: absolute;
  top: calc(50% + 70px);
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000000;
`;

export const DialogSafeOverlay = styled.div`
  > div {
    position: absolute;
    inset: 0;
  }

  > div > div:first-child {
    z-index: 999998;
  }

  > div > div:nth-child(2) {
    z-index: 999999;
  }
`;
